var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-charcounter",class:_vm.remainingChars >= 0 ? 'has-text-success' : 'has-text-danger'},[_vm._v(" "+_vm._s(_vm.remainingChars)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }